<template>
  <a-modal
    ref="createModal"
    :title="fromType === 'edit' ? '编辑操作' : '新增操作'"
    :width="640"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="loading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="名称" prop="codeName">
          <a-input v-model="form.codeName" placeholder="请输入名称" />
        </a-form-model-item>
        <a-form-model-item label="前缀" prop="codePrefix">
          <a-input v-model="form.codePrefix" placeholder="请输入前缀" />
        </a-form-model-item>
        <a-form-model-item label="年" prop="codeYear">
          <a-radio-group button-style="solid" defaultValue="yyyy" v-model="form.codeYear">
            <a-radio-button value="yyyy" >yyyy</a-radio-button>
            <a-radio-button value="yy" >yy</a-radio-button>
            <a-radio-button value="">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="月" prop="codeMonth">
          <a-radio-group button-style="solid" defaultValue="MM" v-model="form.codeMonth">
            <a-radio-button value="MM" >MM</a-radio-button>
            <a-radio-button value="">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="日" prop="codeDay">
          <a-radio-group button-style="solid" defaultValue="dd" v-model="form.codeDay">
            <a-radio-button value="dd" >dd</a-radio-button>
            <a-radio-button value="">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="时" prop="codeHour">
          <a-radio-group button-style="solid" defaultValue="HH" v-model="form.codeHour">
            <a-radio-button value="HH" >HH</a-radio-button>
            <a-radio-button value="">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="分" prop="codeMinute">
          <a-radio-group button-style="solid" defaultValue="mm" v-model="form.codeMinute">
            <a-radio-button value="mm" >mm</a-radio-button>
            <a-radio-button value="">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="秒" prop="codeSecond" hidden="hidden">
          <a-radio-group button-style="solid" defaultValue="" v-model="form.codeSecond">
            <a-radio-button value="ss" >ss</a-radio-button>
            <a-radio-button value="">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="毫秒" prop="codeMillisecond" hidden="hidden">
          <a-radio-group button-style="solid" defaultValue="" v-model="form.codeMillisecond">
            <a-radio-button value="SSS" >SSS</a-radio-button>
            <a-radio-button value="">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="流水号长度" prop="numCount">
          <a-input-number v-model="form.numCount" :min="1" :max="100"/>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { addType, updateType } from '@/api/system/codeconfig'
// 表单字段
export default {
  data () {
    return {
      // 状态数据字典
      statusOptions: [],
      // 当前控件配置:
      confirmLoading: false,
      // readOnly: false,
      visible: false,
      loading: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        codeName: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        numCount: [
          { required: true, message: '长度不能为空', trigger: 'blur' }
        ]
      },
      fromType: ""
    }
  },
  created () {
    this.getDicts('sys_normal_disable').then(response => {
      this.statusOptions = response.data
    })
  },
  methods: {
    // 由于要用传进来的值做判断,将显示和隐藏放在内部做处理
    show (data) {
      if (data) {
        // 修改行为
        this.form = Object.assign({}, data) || {}
        this.fromType = "edit"
      } else {
        // 新增行为
        // 刷新表单,查询角色树
        this.reset()
        data = {
          codeYear: "yyyy",
          codeMonth: "MM",
          codeDay: "dd",
          codeHour: "HH",
          codeMinute: "mm",
          codeSecond: "",
          codeMillisecond: "",
          numCount: 4
        }
        this.form = Object.assign({}, data) || {}
        this.fromType = "add"
      }
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.visible = false
      this.reset()
    },
    confirm () {
      this.confirmLoading = true
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // 进行新增行为:
          if (this.form.id > 0) {
            // 刷新表格
            updateType(this.form).then(response => {
              if (response.code === 200) {
                this.$message.success('修改成功')
                // 关闭本组件
                this.visible = false
                // 调用外部刷新列表方法
                this.$emit('handle-success')
                // 刷新表单
                this.reset()
                this.confirmLoading = false
              } else {
                this.$message.error(response.msg)
                this.confirmLoading = false
              }
            }).catch(e => {
              this.confirmLoading = false
            })
          } else {
            // 新增
            addType(this.form).then(response => {
              if (response.code === 200) {
                this.$message.success('新增成功')
                // 关闭本组件
                this.visible = false
                // 调用外部刷新列表方法
                this.$emit('handle-success')
                // 刷新表单
                this.reset()
                this.confirmLoading = false
              } else {
                this.$message.error(response.msg)
                this.confirmLoading = false
              }
            }).catch(e => {
              this.confirmLoading = false
            })
          }
        } else {
          return (this.confirmLoading = false)
        }
      })
    },
    // 表单重置
    reset () {
      this.form = {
        lookupName: undefined,
        lookupType: undefined,
        status: undefined,
        remark: undefined
      }
    }
  }
}
</script>
